export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS'

    $('[data-video-play]').click(function(e) {
		e.preventDefault();

		$('[data-video]')[0].play();

    });

    $('[data-video-stop]').click(function(e) {
		e.preventDefault();

		$('[data-video]')[0].pause();

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js